import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { ToolManager2DService } from '../../tools/shared/tool-manager-2d.service';

@Component({
  selector: 'h3-secondary-toolbar-2d-objectless',
  templateUrl: './secondary-toolbar-2d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SecondaryToolbar2DComponent
  extends DirectiveSuperclass
  implements AfterViewInit
{
  @ViewChild('insertionPoint', { read: ViewContainerRef })
  insertionPoint!: ViewContainerRef;

  private toolManager = inject(ToolManager2DService);
  private injector = inject(Injector);

  ngAfterViewInit() {
    this.subscribeTo(this.toolManager.selectedActivatedTool$, (tool) => {
      this.insertionPoint.clear();
      if (!tool?.secondaryToolbarType) {
        return;
      }

      const componentRef = this.insertionPoint.createComponent(
        tool.secondaryToolbarType,
        { injector: this.injector },
      );
      componentRef.instance.tool = tool;
      componentRef.changeDetectorRef.markForCheck();
    });
  }
}
